import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/authContexts";
import Icon from "@mdi/react";
import { mdiLogin, mdiShieldLockOutline } from "@mdi/js";

const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const { login, fetchUser } = useAuth();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);

        if (!email || !password) {
            setError("Por favor, completa todos los campos.");
            return;
        }

        try {
            const result = await login(email, password);
            if (result === true) {
                await fetchUser();
            } else {
                setError(typeof result === "string" ? result : "Credenciales inválidas.");
            }
        } catch (e) {
            setError("Error en el inicio de sesión. Intenta nuevamente.");
            console.error(e.message);
        }
    };

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-blue-200 p-4">
            {/* Tarjeta de Login */}
            <div className="bg-white p-8 rounded-lg shadow-lg text-center w-full max-w-md z-10">
                {/* Ícono con fondo circular */}
                <div className="flex items-center justify-center mb-4">
                    <div className="bg-gray-400 p-3 rounded-full flex items-center justify-center">
                        <Icon path={mdiShieldLockOutline} size={1.8} className="text-white" />
                    </div>
                </div>

                <h3 className="text-2xl font-bold text-gray-800 mb-6">Login</h3>

                {/* Formulario */}
                <form onSubmit={handleSubmit} className="space-y-6">
                    {/* Input de Email con efecto flotante */}
                    <div className="relative">
                        <input
                            type="email"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="peer w-full px-3 pt-6 pb-2 border border-blue-500 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            required
                        />
                        <label
                            htmlFor="email"
                            className="absolute left-3 top-2 text-gray-500 text-sm transition-all peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-placeholder-shown:top-5 peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-600"
                        >
                            Correo *
                        </label>
                    </div>

                    {/* Input de Contraseña con efecto flotante */}
                    <div className="relative">
                        <input
                            type="password"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="peer w-full px-3 pt-6 pb-2 border border-blue-500 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            required
                        />
                        <label
                            htmlFor="password"
                            className="absolute left-3 top-2 text-gray-500 text-sm transition-all peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-placeholder-shown:top-5 peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-600"
                        >
                            Contraseña *
                        </label>
                    </div>

                    {/* Botón de Login */}
                    <button
                        type="submit"
                        className="w-full p-3 bg-red-500 text-white rounded hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-300 flex items-center justify-center gap-2"
                    >
                        <Icon path={mdiLogin} size={1.2} />
                        Login
                    </button>
                </form>

                {/* Opciones de Recordar y Olvidar Contraseña */}
                <div className="flex justify-between items-center mt-4">
                    <a href="#" className="text-sm font-semibold text-blue-500 hover:text-blue-700">
                        ¿Olvidó contraseña?
                    </a>
                    <div className="flex items-center space-x-2">
                        <input
                            id="default_remember"
                            type="checkbox"
                            className="w-4 h-4 text-blue-500 bg-gray-100 border-gray-300 rounded focus:ring-blue-400"
                        />
                        <label htmlFor="default_remember" className="text-sm font-medium text-gray-700">
                            Recordarme
                        </label>
                    </div>
                </div>

                {/* Mensaje de Error */}
                {error && <p className="text-red-500 mt-2">{error}</p>}
            </div>
        </div>
    );
};

export default Login;